import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VisitTotalProductsUsedAreaMonitorItemModel } from '../../visit-day-details.service';

export interface ProductUsageDetailsDialogData {
  productName: string;
  details: VisitTotalProductsUsedAreaMonitorItemModel[];
}

@Component({
  selector: 'app-product-usage-details-dialog',
  templateUrl: './product-usage-details-dialog.component.html',
  styleUrls: ['./product-usage-details-dialog.component.scss'],
})
export class ProductUsageDetailsDialogComponent {
  public productName: string;
  public details: VisitTotalProductsUsedAreaMonitorItemModel[];

  constructor(
    public dialogRef: MatDialogRef<ProductUsageDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProductUsageDetailsDialogData
  ) {
    this.productName = data.productName || '';
    this.details = data.details || [];
    dialogRef.disableClose = false;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
